import Vue from "vue";
import Router from "vue-router";
import Container from "../components/global/container/Container.vue";
import Login from "../components/global/login/Login.vue";
import VerificationLink from "../components/global/login/resendVerificationMail.vue";
import VerifyUser from "../components/global/login/varify-user.vue";
import VerifyMail from "../components/global/login/varify-mail.vue";
import ResetPassword from '../components/global/login/forgotpassword.vue'
import setPassword from '../components/global/login/setPassword.vue'
import ForgotPassword from '../components/global/login/email.vue'
import Register from "../components/global/register/Register.vue";
import Register2nd from "../components/global/register-2nd/Register-2nd.vue";
import Chatroom from "../components/global/chatroom/Chatroom.vue";
import ContactInqury from "../components/global/contact-inqury/Contact-Inqury.vue";
import PrivacyPolicy from "../components/global/privacy-policy/privacy-policy.vue";
import TermsOfService from "../components/global/terms-of-service/terms-of-service.vue";

import AuthGuard from "./auth-guard";
import EngineerGuard from "./engineer-guard";
import CompanyGuard from "./company-guard";
import PageNotFound from "../components/global/404/404.vue";
import maintenance from "../components/global/maintenance/maintenance.vue";
import AboutUs from "../components/global/about-us.vue";

import EngineerCompanyList from "../components/engineer/e_company_list.vue";
import EngineerRecruitList from "../components/engineer/e_recruit_list.vue";
import EngineerProfile from "../components/engineer/e_engineer_profile.vue";
import EngineerProfileEdit from "../components/engineer/e_engineer_profile_edit.vue";
import EngineerFavoritedCompany from "../components/engineer/e_favorited_company.vue";
import EngineerFavoritedRecruit from "../components/engineer/e_favorited_recruit.vue";
import EngineerFavoritedReplay from "../components/engineer/e_engineer_replay.vue";
import EngineerFavoritedUnanswered from "../components/engineer/e_engineer_unanswered.vue";
import EngineerCompanyDetail from "../components/engineer/company_detail.vue";
import EngineerChatAction from '../components/engineer/e_chataction-list.vue'
import EngineerFavoriteByCompany from '../components/engineer/e_engineer_favoritedByCompanies.vue'
import EngineerSkill from '../components/engineer/e_skill.vue'
import EngineerNickname from '../components/engineer/nickname.vue'
import EngineerUsageGuide from '../components/engineer/e_usage_guide.vue'
import EnginnerSettingMail from "../components/engineer/e_mail_setting.vue"
import EnginnerResumeUp from "../components/engineer/resume_up.vue"
import MessageFromAdmin from "../components/engineer/admin_message.vue"

import CompanyProfile from "../components/company/company_profile.vue";
import CompanyProfileEdit from "../components/company/company_profile_edit.vue";
import CompanyRecuritAdd from "../components/company/company_recruit_add.vue";
import CompanyRecuritedit from "../components/company/company_recruit_edit.vue";
import CompanyRecuritList from "../components/company/company_recruit_list.vue";
import CompanyRecuritDetail from "../components/company/company_recruit_detail.vue";
import CompanyUserProfile from "../components/company/company_user_profile.vue";
import CompanyUserProfileEdit from "../components/company/company_user_profile_edit.vue";
import CompanyEngineerDetail from "../components/company/company_engineer_detail.vue";
import CompanyChataction from "../components/company/chataction_list.vue";
import CompanyFavoriteEngineer from "../components/company/company_engineer_list.vue";
import CompanyFavoritedEngineer from "../components/company/company_favorited_engineer.vue";
import CompanyInterestedEngineer from "../components/company/company_interested_engineer.vue";
import CompanySettingMail from "../components/company/company_mail_setting.vue"

Vue.use(Router);

const routes = [{
    path: '/user/verification/:token',
    component: VerifyUser
  },
  {
    path: '/email/verification/:token',
    component: VerifyMail
  },
  {
    path: "",
    redirect: "/global/signin",
    pathMatch: "full"
  },

  {
    path: "/global",
    redirect: { name: 'signin' }
  },

  {
    path: "*",
    redirect: "/global/PageNotFound"
  },
  //Global Path
  {
    path: "/global/",
    component: Container,
    children: [{
        path: "signin",
        name: 'signin',
        component: Login
      },
      {
        path: "about-us",
        component: AboutUs
      },
      {
        path: "register",
        component: Register
      },
      {
        path: "register/:id",
        component: Register
      },
      {
        path: "register_2nd",
        component: Register2nd
      },
      {
        path: "chatroom/:id",
        name: 'chatRoom',
        component: Chatroom,
        beforeEnter: AuthGuard
      },
      {
        path: "contact-inqury",
        component: ContactInqury,
      },
      {
        path: "privacy-policy",
        component: PrivacyPolicy,
      },
      {
        path: "terms-of-service",
        component: TermsOfService,
      },
      {
        path: "PageNotFound",
        component: PageNotFound
      },
      {
        path: "maintenance",
        component: maintenance
      },
      {
        path: 'user/reset-password/:code',
        name: 'resetPassword',
        component: ResetPassword
      },
      {
        path: 'user/set-password/:code',
        name: 'setPassword',
        component: setPassword
      },
      {
        path: 'user/forgot-password',
        name: 'forgotPassword',
        component: ForgotPassword
      },
      {
        path: "resend-verification-link",
        name: "VerificationLink",
        component: VerificationLink,

      },
    ]
  },

  //Engineer Path
  {
    path: "/engineer/",
    component: Container,
    redirect: 'profile',
    beforeEnter: AuthGuard,
    children: [
//      {
//        path: "company-list",
//        name: 'engineerCompanyList',
//        component: EngineerCompanyList,
//        beforeEnter: EngineerGuard
//      },
//      {
//        path: "recruit-list",
//        name: 'engineerRecruitList',
//        component: EngineerRecruitList,
//        beforeEnter: EngineerGuard
//      },
      {
        path: "profile/:uid",
        component: EngineerProfile,
        beforeEnter: EngineerGuard
      },
//      {
//        path: "company-detail/:cid",
//        name: "companyDetail",
//        component: EngineerCompanyDetail,
//        beforeEnter: EngineerGuard
//      },
      {
        path: "profile-edit/:uid",
        name: "engineerProfileEdit",
        component: EngineerProfileEdit,
        beforeEnter: EngineerGuard
      },
      {
        path: "chataction-list",
        name: 'engineerChatAction',
        component: EngineerChatAction,
        beforeEnter: EngineerGuard
      },
      {
        path: "message-from-admin/:messageId",
        name: 'messageFormAdmin',
        component: MessageFromAdmin,
        beforeEnter: AuthGuard
      },
//      {
//        path: "favorited-company/:uid",
//        name: "favoritedCompany",
//        component: EngineerFavoritedCompany,
//        beforeEnter: EngineerGuard,
//      },
//      {
//        path: "favorited-recruit/:uid",
//        name: "favoritedRecruit",
//        component: EngineerFavoritedRecruit,
//        beforeEnter: EngineerGuard
//      },
      {
        path: "replay/:uid",
        name: "engineerReplay",
        component: EngineerFavoritedReplay,
        beforeEnter: EngineerGuard
      },
      {
        path: "unanswered/:uid",
        name: "engineerUnanswered",
        component: EngineerFavoritedUnanswered,
        beforeEnter: EngineerGuard
      },
//      {
//        path: "favorited-by-company/:uid",
//        name: "engineerFavoritedByCompany",
//        component: EngineerFavoriteByCompany,
//        beforeEnter: EngineerGuard
//      },
      {
        path: "skill-update",
        name: "skillUpdate",
        component: EngineerSkill,
        beforeEnter: EngineerGuard,
      },
      {
        path: "nickname",
        name: "nickname",
        component: EngineerNickname,
        beforeEnter: EngineerGuard
      },
      {
        path: "setting",
        name: "EngineerSettingMail",
        component: EnginnerSettingMail,
        beforeEnter: EngineerGuard
      },
      {
        path: "usage-guide",
        name: "EngineerUsageGuide",
        component: EngineerUsageGuide,
        beforeEnter: EngineerGuard
      },
      {
        path: "resume-up",
        name: "ResumeUP",
        component: EnginnerResumeUp,
        beforeEnter: EngineerGuard
      },
    ]
  },

  //Company Path
  {
    path: "/company/",
    component: Container,
    redirect: 'company',
    beforeEnter: AuthGuard,
    children: [{
        path: "profile/:cid/:uid",
        name: "companyProfile",
        component: CompanyProfile,
        beforeEnter: CompanyGuard
      },
      {
        path: "engineer-list/:cid/:uid",
        name: "engineerFavorite",
        component: CompanyFavoriteEngineer,
        beforeEnter: CompanyGuard
      },
      {
        path: "favorited-engineer/:cid/:uid",
        name: "engineerFavorited",
        component: CompanyFavoritedEngineer,
        beforeEnter: CompanyGuard
      },
      {
        path: "interested-engineer-list/:cid/:uid",
        name: "CompanyInterestedEngineer",
        component: CompanyInterestedEngineer,
        beforeEnter: CompanyGuard
      },
      {
        path: "company-user-profile/:cid/:uid",
        name: 'companyUserProfile',
        component: CompanyUserProfile,
        beforeEnter: CompanyGuard
      },
      {
        path: "company-user-profile-edit/:cid/:uid",
        name: 'companyUserProfileEdit',
        component: CompanyUserProfileEdit,
        beforeEnter: CompanyGuard
      },
      {
        path: "setting",
        name: "companySettingMail",
        component: CompanySettingMail,
        beforeEnter: CompanyGuard
      },
      {
        path: "profile-edit/:cid/:uid",
        name: "companyProfileEdit",
        component: CompanyProfileEdit,
        beforeEnter: CompanyGuard
      },
      {
        path: "recruit-add/:cid/:uid",
        name: "companyRecuritAdd",
        component: CompanyRecuritAdd,
        beforeEnter: CompanyGuard
      },
      {
        path: "recruit-edit/:cid/:uid/:rid",
        name: "companyRecuritEdit",
        component: CompanyRecuritedit,
        beforeEnter: CompanyGuard
      },
      {
        path: "recruit-list/:cid/:uid",
        name: "companyRecuritList",
        component: CompanyRecuritList,
        beforeEnter: CompanyGuard
      },
//      {
//        path: "recruit-detail/:rid",
//        name: "companyRecuritDetail",
//        component: CompanyRecuritDetail,
//      },
      {
        path: "chataction-list",
        name: 'companyChatAction',
        component: CompanyChataction,
        beforeEnter: CompanyGuard
      },
      {
        path: "engineer-detail/:uid",
        name: "companyEngineerDetail",
        component: CompanyEngineerDetail,
        beforeEnter: CompanyGuard
      },
    ]
  }
];

export default new Router({
  mode: "history",
  routes
});
